/**
 * Axios-based adapter for StepOverHttpClient.
 * Used by the browser UI (StepOverMenuButton) to call the backend through the existing mp agent.
 */
import { getMpAgent } from '@cibo/core'
import { StepOverHttpClient, StepOverResponse } from './stepOverTypes'

export function createAxiosStepOverClient(): StepOverHttpClient {
  const agent = getMpAgent()

  return {
    async get<T>(url: string): Promise<StepOverResponse<T>> {
      try {
        const resp = await agent.get<T>(url)
        return { ok: resp.status >= 200 && resp.status < 300, status: resp.status, data: resp.data }
      } catch (err: any) {
        const status = err?.response?.status ?? 500
        return { ok: false, status, data: err?.response?.data }
      }
    },
    async post<T>(
      url: string,
      data?: unknown,
      options?: { timeout?: number }
    ): Promise<StepOverResponse<T>> {
      try {
        const resp = await agent.post<T>(
          url,
          data,
          options?.timeout ? { timeout: options.timeout } : undefined
        )
        return { ok: resp.status >= 200 && resp.status < 300, status: resp.status, data: resp.data }
      } catch (err: any) {
        const status = err?.response?.status ?? 500
        return { ok: false, status, data: err?.response?.data }
      }
    },
    async patch<T>(url: string, data?: unknown): Promise<StepOverResponse<T>> {
      try {
        const resp = await agent.patch<T>(url, data)
        return { ok: resp.status >= 200 && resp.status < 300, status: resp.status, data: resp.data }
      } catch (err: any) {
        const status = err?.response?.status ?? 500
        return { ok: false, status, data: err?.response?.data }
      }
    },
    async put<T>(url: string, data?: unknown): Promise<StepOverResponse<T>> {
      try {
        const resp = await agent.put<T>(url, data)
        return { ok: resp.status >= 200 && resp.status < 300, status: resp.status, data: resp.data }
      } catch (err: any) {
        const status = err?.response?.status ?? 500
        return { ok: false, status, data: err?.response?.data }
      }
    },
  }
}
